export default (open, selected, rows, search, canCreate) => ({
    open,
    selected,
    rows,
    search,
    canCreate,
    shortcuts: {
        ['@click.outside']() {
            this.open = false
        },
        ['@keyup.enter']() {
            if (this.selected === null) {
                return
            }

            const index = this.rows.findIndex(row => row.id == this.selected)
            const row = this.rows[index]
            this.pickOption(row.id)
        },
        ['@keyup.esc']() {
            this.open = false
        },
        ['@keyup.up']() {
            if (!this.open) {
                return
            }

            let row

            if (this.selected === null) {
                row = this.rows[this.rows.length - 1]
                return this.selectOption(row.id)
            }

            const index = this.rows.findIndex(row => row.id == this.selected)

            if (this.rows[index - 1] === undefined) {
                row = this.rows[this.rows.length - 1];
                return this.selectOption(row.id)
            }

            row = this.rows[index - 1];
            return this.selectOption(row.id)
        },
        ['@keyup.down']() {
            if (!this.open) {
                return this.open = true
            }

            let row

            if (this.selected === null) {
                row = this.rows[0]
                return this.selectOption(row.id)
            }

            const index = this.rows.findIndex(row => row.id == this.selected)

            if (this.rows[index + 1] === undefined) {
                row = this.rows[0]
                return this.selectOption(row.id)
            }

            row = this.rows[index + 1]
            return this.selectOption(row.id)
        },
    },
    get showCreationButton() {
        return this.canCreate
            && this.search
            && !this.rows.find(row => row.name.toLowerCase() === this.search.toLowerCase())
    },
    selectOption(id) {
        this.selected = id
    },
    pickOption(id) {
        this.selectOption(id)
        this.open = false

        if (!id) {
            this.clearSearch()
        }
    },
    clearSearch() {
        if (!this.search) {
            this.open = true

            return;
        }

        this.search = ''
    },
    fillInputWithSelectedValue(value) {
        if (!value) {
            this.$refs['search-input'].value = '';
            return;
        }

        const index = this.rows.findIndex(row => row.id == value)
        const row = this.rows[index]

        this.$refs['search-input'].value = row?.name || '';
    },
    init() {
        this.$watch('selected', value => this.fillInputWithSelectedValue(value));
        this.$wire.$watch('useScopes', (value) => {
            this.$wire.updateRows();
        });

        this.$nextTick(() => {
            this.fillInputWithSelectedValue(this.selected);
        })
    }
})
